import type { Block, ImageWrapper } from 'src/__generated__/graphqlTypes';

/** For now it take only fist image from {@param images} to not overcomplicated it  */
export const getLocalImage = (image?: Block['image'], images?: Array<ImageWrapper>) => {
  if (image?.url) {
    return { image };
  }

  if (images?.length) {
    const { image, width, height } = images[0];

    return {
      image,
      ...(width && height && { size: { height, width } }),
    };
  }

  return null;
};
